import { s_get_components, s_raise_event, s_remove_from_parent } from "../runner/py-util";
// The *real* base Container class.
// It's an abstract base class that provides usable implementations of clear() and raise_event_on_children(),
// relying on the implementer to provide add_component(), get_components(), and propagate page events.
export const Container = Sk.abstr.buildNativeClass("anvil.Container", {
    constructor: function Container() { },
    methods: {
        "clear": {
            $meth() {
                return Sk.misceval.chain(undefined, ...Sk.misceval.callsimArray(this.tp$getattr(s_get_components), []).$items().map(pyComponent => () => Sk.misceval.callsimOrSuspendArray(pyComponent.tp$getattr(s_remove_from_parent), [])));
            },
            flags: { NoArgs: true }
        },
        "raise_event_on_children": {
            $meth(args, kws) {
                Sk.abstr.checkOneArg("raise_event_on_children", args);
                const pyEventName = args[0];
                if (!Sk.builtin.checkString(pyEventName)) {
                    throw new Sk.builtin.TypeError("event_name must be a string");
                }
                return Sk.misceval.chain(undefined, ...Sk.misceval.callsimArray(this.tp$getattr(s_get_components), []).$items().map(pyComponent => () => Sk.misceval.callsimOrSuspendArray(pyComponent.tp$getattr(s_raise_event), [pyEventName], kws)));
            },
            flags: { FastCall: true }
        }
    }
});
